var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    {
      staticClass: "class-page",
      staticStyle: { padding: "15px" },
      attrs: { id: "classPage" }
    },
    [
      _c("class-page-header", {
        attrs: {
          course: _vm.course,
          menu: _vm.menu,
          details: _vm.details,
          "current-section": parseInt(_vm.sectionData.FOLDER_ID),
          "course-content": _vm.courseContent
        }
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "class-page-body" },
        [
          _c("div", {
            domProps: { innerHTML: _vm._s(_vm.sectionData.FOLDER_CONTENT) }
          }),
          _vm._v(" "),
          _c("class-items", {
            attrs: { "items-data": _vm.sectionData.REPORTS, "folder-type": "P" }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c("class-page-footer", {
        attrs: {
          course: _vm.course,
          menu: _vm.menu,
          "current-section": parseInt(_vm.sectionData.FOLDER_ID),
          "course-content": _vm.courseContent
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }